import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedFlex,
  Formatters,
} from '../../coreui';

import SummaryItem from './SummaryItem';

const DashboardSummary = ({ data }) => {
  return (
    <ExtendedFlex
      flexDirection="column"
      width={1}
      minWidth={280}
      maxWidth={['75%', 1540]}
      px={[0, 50]}
      pb={[40, 50]}
    >
      <ExtendedFlex
        py={[0, 30, 50]}
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        alignItems={['flex-start']}
        width="100%"
      >
        {
          data.activeInvestmentsData.totalInvested !== undefined &&
          <SummaryItem
            value={data.activeInvestmentsData.totalInvested.value}
            label="TOTAL INVESTED-ACTIVE"
            dataType="D8"
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.activeInvestmentsData.totalInvested.tooltip}
          />
        }
        {
          data.activeInvestmentsData.totalDistributions !== undefined &&
          <SummaryItem
            value={data.activeInvestmentsData.totalDistributions.value}
            label="TOTAL DISTRIBUTIONS-ACTIVE"
            dataType="D8"
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.activeInvestmentsData.totalDistributions.tooltip}
          />
        }
      </ExtendedFlex>
      <ExtendedFlex
        py={[0, 30, 50]}
        flexDirection={['column', 'row']}
        justifyContent="space-between"
        width="100%"
      >
        {
          data.activeInvestmentsData.cashInvested !== undefined &&
          <SummaryItem
            value={data.activeInvestmentsData.cashInvested.value}
            label="CASH INVESTED"
            dataType="D7"
            valueFormat={Formatters.DOLLARS_DECIMALS}
          />
        }
        {
          data.activeInvestmentsData.distributionsInvested !== undefined &&
          <SummaryItem
            value={data.activeInvestmentsData.distributionsInvested.value}
            label="DISTRIBUTIONS REINVESTED"
            dataType="D7"
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.activeInvestmentsData.distributionsInvested.tooltip}
          />
        }
        {
          data.activeInvestmentsData.cashDistributionsPaid !== undefined &&
          <SummaryItem
            value={data.activeInvestmentsData.cashDistributionsPaid.value}
            label="CASH DISTRIBUTION PAID"
            dataType="D7"
            valueFormat={Formatters.DOLLARS_DECIMALS}
          />
        }
      </ExtendedFlex>
    </ExtendedFlex>
  );
};

DashboardSummary.propTypes = {
  data: PropTypes.object,
};

export default DashboardSummary;
